export function isEmpty(v) {
  if (v === "0") return false;
  else if (v === 0) return false;
  else if (!!v) return false;

  return true;
}


// WEBPACK FOOTER //
// ./src/utils/index.js